export default {"src":"/_next/static/media/profile-wheel.bbdbf4f2.svg","height":560,"width":597,"blurWidth":0,"blurHeight":0};